import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './styles.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function App() {
  const [services, setServices] = useState([]);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    fetchServices();
    checkUser();
  }, []);

  const fetchServices = async () => {
    try {
      const res = await axios.get(`${API_URL}/services`);
      setServices(res.data);
    } catch (err) {
      console.error('Error fetching services:', err);
    } finally {
      setLoading(false);
    }
  };

  const checkUser = () => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.get(`${API_URL}/me`, {
        headers: { 'x-auth-token': token }
      })
      .then(res => setUser(res.data))
      .catch(() => localStorage.removeItem('token'));
    }
  };

  const handleLogin = async (email, password) => {
    try {
      const res = await axios.post(`${API_URL}/login`, { email, password });
      localStorage.setItem('token', res.data.token);
      setUser(res.data.user);
      setShowLogin(false);
      alert('Login successful! Welcome ' + res.data.user.name);
    } catch (err) {
      alert('Login failed: ' + (err.response?.data?.msg || 'Please try again'));
    }
  };

  const handleRegister = async (name, email, password) => {
    try {
      const res = await axios.post(`${API_URL}/register`, { name, email, password });
      localStorage.setItem('token', res.data.token);
      setUser(res.data.user);
      setShowLogin(false);
      alert('Registration successful! Welcome ' + res.data.user.name);
    } catch (err) {
      alert('Registration failed: ' + (err.response?.data?.msg || 'Please try again'));
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  return (
    <div className="app">
      <Navbar 
        user={user} 
        onLogout={handleLogout} 
        onLogin={handleLogin}
        onRegister={handleRegister}
        showLogin={showLogin}
        setShowLogin={setShowLogin}
      />
      <Hero />
      <Services services={services} loading={loading} />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;